import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '蘑菇视频',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '品牌介绍', path: '/about#brand' },
    ],
  },
  {
    title: '下载安装',
    links: [
      { label: '安卓版下载', path: '/category/download' },
      { label: 'iOS版下载', path: '/category/download' },
      { label: '电脑版下载', path: '/category/download' },
    ],
  },
  {
    title: '帮助支持',
    links: [
      { label: '使用教程', path: '/category/tutorial' },
      { label: '常见问题', path: '/category/faq' },
      { label: '功能特色', path: '/category/features' },
    ],
  },
  {
    title: '法律信息',
    links: [
      { label: '用户协议', path: '/article/mogushipin-terms' },
      { label: '隐私政策', path: '/article/mogushipin-privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="container-page py-12 md:py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-10">
          {footerLinks.map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4 font-heading">
                {section.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-md bg-primary-500 flex items-center justify-center">
              <i className="ri-play-circle-fill text-sm text-white"></i>
            </div>
            <span className="text-sm text-foreground-500">
              &copy; {new Date().getFullYear()} 蘑菇视频 版权所有
            </span>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer" aria-label="QQ">
              <i className="ri-qq-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}